import { render, staticRenderFns } from "./ZuJian_ShuiNi_KongBai.vue?vue&type=template&id=512b8b96&"
import script from "./ZuJian_ShuiNi_KongBai.vue?vue&type=script&lang=js&"
export * from "./ZuJian_ShuiNi_KongBai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports